// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__VxhLn","root--noheader":"Page_root--noheader__wj2Jd","skipToMain":"Page_skipToMain__h_mw9","rotation":"Page_rotation__9BSJ4"};